import React from 'react';

const ArrowDown = props => (
  <svg
    id="arrow-down"
    width={18}
    height={10}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 10"
    {...props}
  >
    <path
      d="M9.333 8.833 17 1.167M9.333 8.833 1.667 1.167"
      stroke="#647A85"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDown;
